module.exports = __webpack_public_path__ + "static/media/36x36-16.9bad0359.png";